var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pdf-box"},[(_vm.path)?_c('Pdf',{ref:"jsPdf",attrs:{"pdfUrl":_vm.path,"platform":_vm.platform,"watermark-text":_vm.watermark,"is_encrypt":_vm.is_encrypt}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }